import app from '../../../app';

export default function () {
  if (app.config.mode.isLink || app.config.mode.isExport) {
    return user.settings.user_id;
  }
  return user.id;
}
